import RecipientWellWithFindControlViewState from 'owa-recipient-common/lib/store/schema/RecipientWellWithFindControlViewState';
import { action } from 'satcheljs/lib/legacy';

export default action('setHasSearchedDirectory')(function setHasSearchedDirectory(
    viewstate: RecipientWellWithFindControlViewState,
    hasSearchedDirectory: boolean
) {
    viewstate.hasSearchedDirectory = hasSearchedDirectory;
});
